export default __webpack_public_path__ + "static/media/logo-mercantil.d2ffb576.jpg";